import React from 'react';
import { Typography, Button, Fade, Stack } from '@mui/material';
import { Sparkles, Rocket } from 'lucide-mui';
import { useLimits } from '../../../plan/hooks/limits';
import AICreditLearnMore from '../../shared/AICreditLearnMore';

const ChatLimitReached: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const guardLimits = useLimits();

  return (
    <Fade in timeout={450}>
      <Stack
        spacing={2}
        alignItems="center"
        sx={{
          width: '100%',
          py: 2.5,
          px: 2,
          textAlign: 'center',
        }}
      >
        <Sparkles
          style={{
            color: 'var(--mui-palette-info-main)',
            width: '28px',
            height: '28px',
          }}
        />

        <Stack spacing={0.5}>
          <Typography variant="h6">AI Chat Limit Reached</Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 360, mx: 'auto' }}
          >
            Out of AI credits. Upgrade to keep using AI Chat.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1.5}>
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={() => setOpen(true)}
          >
            Learn More
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<Rocket style={{ width: '16px', height: '16px' }} />}
            onClick={() => guardLimits('askAI', () => {})}
          >
            Upgrade Now
          </Button>
        </Stack>

        <AICreditLearnMore
          open={open}
          onClose={() => setOpen(false)}
          onUpgrade={() => guardLimits('askAI', () => {})}
          feature="askAI"
        />
      </Stack>
    </Fade>
  );
};

export default ChatLimitReached;
